import $ from "jquery";
import Template from "./SectionsMapView.ejs";
import makeTemplateFunc from "lodash/template";

const TemplateFunc = makeTemplateFunc(Template);

class SectionsMapView {

    render($container, response) {
        $container.html(TemplateFunc({response}));
        this.fixSize();
        $(window).resize(() => {
            this.fixSize();
        });
      $(window).load(() => {
        this.fixSize();
    })
    }

    fixSize() {
        const $container = $('.js-sections-map-view');
        const $image = $('.js-section-image').removeAttr('style');
        const $mask = $('.js-section-mask').removeAttr('style');
        const containerRatio = $container.width() / $container.height();
        const imageRatio = $image.width() / $image.height();
        if (imageRatio > containerRatio) {
            // horizontal image
            $image.width($image.width() * ( $container.height() / $image.height()));
            $image.height($container.height());
        } else {
            // vertical image
            $image.height($image.height() * ($container.width() / $image.width()));
            $image.width($container.width());
        }
        $mask.width($image.width());
        $mask.height($image.height());
    }
}

export default new SectionsMapView();


// WEBPACK FOOTER //
// ./js/components/SectionsMapView/SectionsMapView.js